import { forwardRef } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import style from '../scss/dropdown.module.scss';

const CustomToggle = forwardRef(({ children, onClick, show }, ref) => (
  <button
    ref={ref}
    type="button"
    className={style.trigger}
    onClick={(e) => { e.preventDefault(); onClick(e); }}
  >
    {children}
    <Icon
      icon="mdi:chevron-down"
      className={`${style.arrow} ${show ? style.arrowOpen : ''}`}
    />
  </button>
));

const DropdownComponent = ({
  trigger,
  label,
  items = [],
  renderItem,
  onSelect,
}) => {
  return (
    <Dropdown>
      <Dropdown.Toggle as={CustomToggle}>
        {trigger ?? <span>{label}</span>}
      </Dropdown.Toggle>
      <Dropdown.Menu className={style.menu} align="end">
        {items.map((item) => (
          <Dropdown.Item
            key={item.value}
            className={style.item}
            onClick={() => onSelect?.(item)}
          >
            {renderItem ? renderItem(item) : item.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropdownComponent;
